import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import styles from './FooterNav.scss';// to import local scss fle

const FooterNav = () => (
  <div className={cn('row', styles.navContainer)}>
    <div className={styles.buttonContainer}>
      <Link to="/">
        <button>HOME</button><br />
      </Link>
      <Link to="/about">
        <button>ABOUT</button><br />
      </Link>
      <Link to="/sports">
        <button>SPORT</button><br />
      </Link>
      <Link to="/pricing">
        <button>PRICING</button><br />
      </Link>
      <Link to="/contact">
        <button>CONTACT</button><br />
      </Link>
    </div>
  </div>
);

export default FooterNav;



// WEBPACK FOOTER //
// ./src/components/FooterNav/FooterNav.js